import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';

import { Accessibility, CimaCore, Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { CmsLevelMoveSuccess } from 'store/cms/models';
import { IXMOptions } from 'core/interfaces';
import { CONFIG_TOKEN } from 'core/constants';

@Component({
    selector: 'xm-level-move-success',
    templateUrl: './success.html',
    styleUrls: ['./success.scss'],
    standalone: false
})
export class XmLevelMoveSuccess implements OnInit, OnDestroy {
    public pageData: SuccessContent;
    public icon: MediaImageOptions;
    public isBillPreviewEnabled: boolean = false;

    private xmStore: XmStore;
    private accessibility: Accessibility;
    private state: StateService;
    private subscriptions: Subscription[] = [];
    private config: IXMOptions;
    private cimaCore: CimaCore;

    constructor(accessibility: Accessibility, state: StateService, @Inject(CONFIG_TOKEN) config: IXMOptions, xmStore: XmStore, cimaCore: CimaCore) {
        Object.assign(this, { accessibility, state, config, xmStore, cimaCore });
    }

    public ngOnInit(): void {
        this.isBillPreviewEnabled = (this.config.ENABLE_BILL_PREVIEW && !this.cimaCore.isBusinessUser) || (this.config.ENABLE_CBM_BILL_PREVIEW && this.cimaCore.isBusinessUser);
        
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsLevelMoveSuccess>(CmsLevelMoveSuccess), (result: CmsLevelMoveSuccess) => {
            if (this.isBillPreviewEnabled) {
                this.pageData = result.billPreviewSuccess;
            } else {
                this.pageData = result.success;
                this.icon = {
                    mobile: Cloudinary.generateMediaFromCms(this.pageData.fiveGIcon)
                };
            }            
        }));

        this.accessibility.focusHash('success-head');
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public endLevelMoveFlow(): void {
        this.state.go('account.activity.landing');
    }
}
